import { render, staticRenderFns } from "./AiAlertSettingsDialog.vue?vue&type=template&id=4c7218d2&scoped=true"
import script from "./AiAlertSettingsDialog.vue?vue&type=script&lang=js"
export * from "./AiAlertSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./AiAlertSettingsDialog.vue?vue&type=style&index=0&id=4c7218d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7218d2",
  null
  
)

export default component.exports